/*
  containerId - в нашей конфигурации не имеет значения,
  т.к. в одном слоте мы показываем несколько баннеров по очереди
  ограничения на страницы (search/explore) в админке AdFox с помощью регулярок
  Параметры компании можно получить открыв код вставки баннера и
  перенести только первые 2 параметра, т.е. исключив параметр pfb (конкртеный баннер) и pfc (кампания)
  Параметр puid3 указывает на слот в котором будет выведен баннер, т.о.
  индексы в хэшмэпе указывают на позицию отельной карточки над которой будет выведен баннер
  Соответственно каждый раз позиция карточек будет смещаться на 1 за баннер и нумерация с 0,
  Т.е. 1 соответствует позиции 2, 9 - позиции 11, 18 - позиции 21
*/

import { isSSR } from 'src/helpers/ssr';

export const HOTEL_LIST_BANNER_SEARCH = 'SEARCH';
export const HOTEL_LIST_BANNER_EXPLORE = 'EXPLORE';

export const LT_PARTNER = 'LT';
export const WL_PARTNER = 'WL';

export const HOTEL_LIST_BANNER_DESKTOP = 'DESKTOP';
export const HOTEL_LIST_BANNER_MOBILE = 'MOBILE';

export const ALLOWED_INDEXES = [1, 9, 18];
export const COUNTRY_FOR_BANNER = isSSR ? undefined : window.COUNTRY_FOR_BANNER;
export const SEARCH_TYPE = isSSR
  ? undefined
  : window.SEARCH_PARAMS?.search_type || window.PACKAGE?.search_type;

export const CAMPAIGNS = {
  [LT_PARTNER]: {
    [HOTEL_LIST_BANNER_DESKTOP]: {
      '1': {
        ownerId: 262376,
        containerId: 'adfox_163913807615992824',
        params: {
          p1: 'cayly',
          p2: 'fxwj',
          puid1: COUNTRY_FOR_BANNER,
          puid2: SEARCH_TYPE,
          puid3: '2',
        },
      },
      '9': {
        ownerId: 262376,
        containerId: 'adfox_163912201060432769',
        params: {
          p1: 'cayly',
          p2: 'fxwj',
          puid1: COUNTRY_FOR_BANNER,
          puid2: SEARCH_TYPE,
          puid3: '11',
        },
      },
      '18': {
        ownerId: 262376,
        containerId: 'adfox_163912185530041546',
        params: {
          p1: 'cayly',
          p2: 'fxwj',
          puid1: COUNTRY_FOR_BANNER,
          puid2: SEARCH_TYPE,
          puid3: '21',
        },
      },
    },
    [HOTEL_LIST_BANNER_MOBILE]: {
      '1': {
        ownerId: 262376,
        containerId: 'adfox_171404543751058067',
        params: {
          p1: 'dcaol',
          p2: 'iyul',
          puid1: COUNTRY_FOR_BANNER,
          puid2: SEARCH_TYPE,
          puid3: '2',
        },
      },
      '9': {
        ownerId: 262376,
        containerId: 'adfox_171404543751088481',
        params: {
          p1: 'dcaol',
          p2: 'iyul',
          puid1: COUNTRY_FOR_BANNER,
          puid2: SEARCH_TYPE,
          puid3: '11',
        },
      },
      '18': {
        ownerId: 262376,
        containerId: 'adfox_171404543751097639',
        params: {
          p1: 'dcaol',
          p2: 'iyul',
          puid1: COUNTRY_FOR_BANNER,
          puid2: SEARCH_TYPE,
          puid3: '21',
        },
      },
    },
  },
  [WL_PARTNER]: {
    [HOTEL_LIST_BANNER_DESKTOP]: {
      '1': {
        ownerId: 262376,
        containerId: 'adfox_160283835842516469',
        params: {
          p1: 'cmqsd',
          p2: 'gywd',
          puid1: COUNTRY_FOR_BANNER,
          puid2: SEARCH_TYPE,
          puid3: '2',
        },
      },
      '9': {
        ownerId: 262376,
        containerId: 'adfox_165027210851526405',
        params: {
          p1: 'cmqsd',
          p2: 'gywd',
          puid1: COUNTRY_FOR_BANNER,
          puid2: SEARCH_TYPE,
          puid3: '11',
        },
      },
      '18': {
        ownerId: 262376,
        containerId: 'adfox_165027219834495786',
        params: {
          p1: 'cmqsd',
          p2: 'gywd',
          puid1: COUNTRY_FOR_BANNER,
          puid2: SEARCH_TYPE,
          puid3: '21',
        },
      },
    },
    [HOTEL_LIST_BANNER_MOBILE]: {},
  },
};
